import { useNumFromQuery } from "./useNumFromQuery";

export const usePageNumFromQuery = (): number => {
  const page = useNumFromQuery("page", 1) as number;

  return page;
};
